import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@lib/useTypedTranslation';

export type AccessDeniedTranslationSuffix = 'PAGE' | 'PRODUCT' | 'WORLD';
interface Props {
  translationKeySuffix: AccessDeniedTranslationSuffix,
  // Optional: the in-world denials (page/product) leave the user inside the app with the sidebar
  // still available, so they render no link. Only the world-level denial - which sits outside any
  // world, behind the Greetings shell - needs one.
  redirectLink?: string,
  redirectLinkMessage?: string
}

export function AccessDenied(props: Props) {
  const { t } = useTranslation('accessDenied');
  return (
    <div id="access-denied-message" style={{ textAlign: 'center', 'paddingTop': '22em' }}>
      <p><b>{t(`ACCESS_DENIED_TO_${props.translationKeySuffix}`)}</b></p>
      <p>{t('CONTACT_ADMIN_MESSAGE')}</p>
      {props.redirectLink && <Link to={props.redirectLink}>{props.redirectLinkMessage}</Link>}
    </div>
  );
}
